import api from "@services/api";
import axios, { AxiosError } from "axios";
import {
  ICreateCreditRating,
  ICreateRelationship,
  ICreateSchedule,
  ICreateTask,
  IDeleteRealtionship,
  IGetCreditRating,
  IGetCreditRatingById,
  IGetOnboardingDocuments,
  IGetOportunityById,
  IGetPdv,
  IGetRealtionship,
  IGetSchedule,
  IGetScheduleById,
  IGetTaskById,
  IGetTasks,
  ITransferOportunityBolsao,
  IUpdateRelationship,
  IUpdateSchedule,
  IUpdateTask,
  IgetCreditRating,
} from "src/@types/Oportunity";

interface IUpdateDocumentStatus {
  NomeDocumento: string;
  Status: string;
}
interface IUpdateDocumentStatus {
  NomeDocumento: string;
  Status: string;
}
interface IUpdateDocumentStatus {
  NomeDocumento: string;
  Status: string;
  Justificativa: string;
}
interface ISendUploadLink {
  email: string;
  nome: string;
  telefone: string;
  OportunidadeId: string;
}
interface IUpdateCreditRating {
  idAvaliacaoCreditoSalesforce: string;
  valorEstimadoCompraEVenda: string;
  idEmpreendimentoSales: string;
  observacoes: string;
  acAtiva: boolean;
  banco: string;
  nomeCorrespondente: string | null;
  CNPJCorrespondente: string | null;
}

export interface IOnboardingDocument {
  origem: string;
  tipoDocumento: string;
  nomeArquivo: string;
  descricao: string;
  statusDocumento: string;
  justificativa: string | null;
  dataUpload: string;
  url: string;
  idAws: string;
}

export interface IContractData {
  idDocumentoPrincipal: string;
  nome: string;
  status: string;
  dataUltimaAtualizacao: string;
  dataCriacao: string;
  assinantesObrigatoriosFinalizados: boolean;
}

interface ISAFIData {
  idEmpreendimentoSales: string;
  codigoBanco: number | null;
  fid: number;
  idAvaliacaoCreditoSalesforce: string;
  opportunityIdSalesforce: string;
  imobiliaria: string;
  valorEstimadoCompraEVenda: number;
  observacao: string;
  status: string;
  CNPJCorrespondente: string | null;
}

interface IUpdateOportunity {
  opportunityIdSalesforce: string;
  OportunidadeId?: string;
  oportunidadeId?: string;
  motivoQueda?: number | null;
  contatoCorretor?: string | null;
  regionalComercial?: string | null;
  origemDaConta?: string | null;
  NomeConta?: string | null;
  accountIdSalesforce: string | null;
  telefonePrincipal?: string | null;
  telefoneComplementar?: string | null;
  emailComplementar?: string | null;
  emailPrincipal?: string | null;
  dataNascimento?: string | null;
  nacionalidade?: string | null;
  faixaEtaria?: string | null;
  sexo?: string | null;
  cpf?: string | null;
  rg?: string | null;
  dataExpedicaoRG?: string | null;
  orgaoExpedidorRG?: string | null;
  profissao?: string | null;
  estadoCivil?: string | null;
  dataCasamento?: string | null;
  regimeCasamento?: string | null;
  empreendimentoDeInteressePrincipal?: string | null;
  campanha?: string | null;
  tipoVenda?: string | null;
  observacao?: string | null;
  pastaPremiada?: number | null;
}

interface IGetCorrespondingRow {
  idEmpreendimento: string;
  regional: string;
  unidadeDeNegocio: string;
  regiao: string | null;
}

interface IGetCorresponding {
  oportunidadeIdSalesforce: string;
}

class OportunityService {
  async getUserByEquip() {
    try {
      const response = await api.get("/autenticacao/obter-usuarios-equipe");
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }
  async transferOportunityBolsao({
    opportunityIdSalesforce,
    contactIdSalesforce,
  }: ITransferOportunityBolsao) {
    const body = { opportunityIdSalesforce, contactIdSalesforce };

    try {
      const response = await api.post(
        "/oportunidade/assumir-oportunidade-bolsao",
        body,
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }
  async getQtdeTransferOportunityBolsao(idContatoCorretorSalesforce: string) {
    try {
      const response = await api.get(
        "/oportunidade/obter-qtde-transferencias-corretor",
        {
          params: { idContatoCorretorSalesforce },
        },
      );
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }
  async getOportunityBolsao() {
    try {
      const response = await api.get("/oportunidade/obter-bolsao");
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }
  async getOportunityById({ OportunidadeId }: IGetOportunityById) {
    try {
      const response = await api.get("/oportunidade/obter-por-id", {
        params: { OportunidadeId },
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async updateOportunity(payload: IUpdateOportunity) {
    try {
      await api.patch("/oportunidade/atualizar", payload);

      return { success: true, err: "" };
    } catch (err) {
      if (err instanceof AxiosError) {
        if (err.response !== undefined) {
          return { success: false, err: err.response!.data as string };
        }
      }
      return {
        success: false,
        err: "Ocorreu algum erro, tente novamente mais tarde",
      };
    }
  }

  async getContracts({
    opportunityIdSalesforce,
  }: {
    opportunityIdSalesforce: string;
  }) {
    try {
      const response = await api.get<IContractData[]>(
        "/oportunidade/obter-contratos",
        {
          params: { OportunidadeId: opportunityIdSalesforce },
        },
      );

      if (response.status === 204) return [];
      return response.data;
    } catch (error) {
      return [];
    }
  }

  async getContractURL(documentId: string) {
    try {
      const response = await api.get<{ url: string }>(
        "/oportunidade/download-contrato",
        {
          params: { documentId },
        },
      );

      return response.data.url;
    } catch (error) {
      return "";
    }
  }

  async getOnboardingDocuments({
    CodigoRelacionamentoComComprador,
    CPF,
  }: IGetOnboardingDocuments) {
    try {
      const response = await api.get<IOnboardingDocument[]>(
        "/oportunidade/obter-documentos",
        {
          params: { CodigoRelacionamentoComComprador, CPF },
        },
      );

      if (response.status === 204) return [];
      return response.data;
    } catch (error) {
      return [];
    }
  }

  async updateDocumentStatus({
    NomeDocumento,
    Status,
    Justificativa,
  }: IUpdateDocumentStatus) {
    try {
      await api.patch("/oportunidade/atualiza-status-documento", {
        params: {
          NomeDocumento,
          Status,
          Justificativa,
        },
      });
      return true;
    } catch {
      return false;
    }
  }

  async sendOnboardingLink(params: ISendUploadLink) {
    try {
      await api.post("/oportunidade/enviar-link", {
        params,
      });

      return true;
    } catch {
      return false;
    }
  }

  async uploadDocument(data: FormData) {
    try {
      await api.post("/oportunidade/post-documento", data);

      return true;
    } catch {
      return false;
    }
  }

  async deleteDocument(idAws: string) {
    try {
      await api.delete("/oportunidade/deletar-documento-s3", {
        params: { idAws },
      });

      return true;
    } catch {
      return false;
    }
  }

  async getSchedule({
    ContactIdSalesforce,
    OpportunityIdSalesforce,
  }: IGetSchedule) {
    try {
      const response = await api.get("/agendamento/obter", {
        params: { ContactIdSalesforce, OpportunityIdSalesforce },
      });

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async deleteSchedule(IdAgendamento: string) {
    try {
      const response = await api.delete("/agendamento/deletar", {
        params: { IdAgendamento },
      });

      return response.data;
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
      return false;
    }
  }

  async updateSchedule({
    idAgendamentoSalesforce,
    observacoes,
  }: IUpdateSchedule) {
    const body = {
      idAgendamentoSalesforce,
      observacoes,
    };

    try {
      const response = await api.patch("/agendamento/atualizar", body);

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async getScheduleById({ idAgendamentoSalesforce }: IGetScheduleById) {
    try {
      const response = await api.get("/agendamento/obter-por-id", {
        params: { idAgendamentoSalesforce },
      });

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async getPdv({ regional }: IGetPdv) {
    try {
      const response = await api.get("/agendamento/obter-pdvs", {
        params: { regional },
      });

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async createSchedule({
    imobiliaria,
    pdv,
    relativoA,
    tipoDeVisita,
    dataAgendamento,
    horaAgendamento,
    empreendimentoDeInteresse,
    unidadeDeNegocio,
    regional,
    observacoes,
    contactIdSalesforce,
  }: ICreateSchedule) {
    const body = {
      imobiliaria,
      pdv,
      relativoA,
      tipoDeVisita,
      dataAgendamento,
      horaAgendamento,
      empreendimentoDeInteresse,
      unidadeDeNegocio,
      regional,
      observacoes,
      contactIdSalesforce,
    };

    try {
      const response = await api.post("/agendamento/inserir", body);

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async getTasks({ OpportunityIdSalesforce }: IGetTasks) {
    try {
      // const response = await api.get("/tarefa/obter", {
      const response = await api.get("/tarefa/obter", {
        params: { OpportunityIdSalesforce },
      });

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async deleteTasks(IdTarefa: string) {
    try {
      const response = await api.delete("/tarefa/deletar", {
        params: { IdTarefa },
      });

      return response.data;
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
      return false;
    }
  }

  async getTasksById({ idTarefaSalesforce }: IGetTaskById) {
    try {
      const response = await api.get("/tarefa/obter-por-id", {
        params: { idTarefaSalesforce },
      });

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async createTask({
    assunto,
    idCorretorSalesforce,
    relativoA,
    dataDeVencimento,
    status,
    tipoDeRegistro,
    comentarios,
    numeroDeTentativas,
  }: ICreateTask) {
    const body = {
      assunto,
      idCorretorSalesforce,
      relativoA,
      dataDeVencimento,
      status,
      tipoDeRegistro,
      comentarios,
      numeroDeTentativas,
    };

    try {
      const response = await api.post("/tarefa/inserir", body);

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async updateTask({
    idTarefaSalesforce,
    numeroDeTentativas,
    comentarios,
    status,
    assunto,
    dataVencimento,
  }: IUpdateTask) {
    const body = {
      idTarefaSalesforce,
      numeroDeTentativas,
      comentarios,
      status,
      assunto,
      dataVencimento,
    };

    try {
      const response = await api.patch("/tarefa/atualizar", body);

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async getCreditRating({
    OpportunityIdSalesforce,
    idEmpreendimentoSales,
    somenteAprovadas,
  }: IgetCreditRating) {
    try {
      const response = await api.get("/analise-de-credito/obter", {
        params: {
          OpportunityIdSalesforce,
          idEmpreendimentoSales,
          somenteAprovadas,
        },
      });

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async getCreditRatingById({
    IdAvaliacaoCreditoSalesforce,
  }: IGetCreditRating) {
    try {
      const response = await api.get("/analise-de-credito/obter-por-id", {
        params: { IdAvaliacaoCreditoSalesforce },
      });

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async createCreditRating({
    opportunityIdSalesforce,
    acAtiva,
    accountIdSalesforce,
    idEmpreendimentoSales,
    imobiliariaId,
    nomeBanco,
    observacoes,
    valorEstimadoCompraEVenda,
    vendaFutura,
    nomeCorrespondente,
    cnpjCorrespondente,
  }: ICreateCreditRating) {
    const body = {
      opportunityIdSalesforce,
      acAtiva,
      accountIdSalesforce,
      idEmpreendimentoSales,
      imobiliariaId,
      nomeBanco,
      observacoes,
      valorEstimadoCompraEVenda,
      vendaFutura,
      nomeCorrespondente,
      cnpjCorrespondente,
    };

    try {
      const response = await api.post("/analise-de-credito/inserir", body);

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async updateCreditRating({
    acAtiva,
    banco,
    idAvaliacaoCreditoSalesforce,
    idEmpreendimentoSales,
    observacoes,
    valorEstimadoCompraEVenda,
    nomeCorrespondente,
    CNPJCorrespondente,
  }: IUpdateCreditRating) {
    const body = {
      acAtiva,
      banco,
      idAvaliacaoCreditoSalesforce,
      idEmpreendimentoSales,
      observacoes,
      valorEstimadoCompraEVenda,
      nomeCorrespondente,
      CNPJCorrespondente,
    };

    try {
      const response = await api.patch("/analise-de-credito/atualizar", body);

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async getRealtionship({ OpportunityIdSalesforce }: IGetRealtionship) {
    try {
      const response = await api.get("/relacionamento-comprador/obter", {
        params: { OpportunityIdSalesforce },
      });

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async getRealtionshipById({
    IdRelacionamentoComprador,
  }: IGetCreditRatingById) {
    try {
      const response = await api.get("/relacionamento-comprador/obter-por-id", {
        params: { IdRelacionamentoComprador },
      });

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async createRelationship({
    accountIdSalesforce,
    cpf,
    idRelacionamentoComprador,
    oportunidade,
    tipoRelacionamento,
    contactIdSalesforceCorretorLogado,
    idAvaliacaoCreditoSalesforce,
    vaiComporRenda,
  }: ICreateRelationship) {
    const body = {
      accountIdSalesforce,
      cpf,
      idRelacionamentoComprador,
      oportunidade,
      tipoRelacionamento,
      contactIdSalesforceCorretorLogado,
      idAvaliacaoCreditoSalesforce,
      vaiComporRenda,
    };

    try {
      const response = await api.post(
        "/relacionamento-comprador/inserir",
        body,
      );

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async updateRelationship({
    accountIdSalesforce,
    cpf,
    idRelacionamentoComprador,
    oportunidade,
    tipoRelacionamento,
    vaiComporRenda,
  }: IUpdateRelationship) {
    const body = {
      accountIdSalesforce,
      cpf,
      idRelacionamentoComprador,
      oportunidade,
      tipoRelacionamento,
      vaiComporRenda,
    };

    try {
      const response = await api.patch(
        "/relacionamento-comprador/atualizar",
        body,
      );

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async deleteRealtionship({ IdRelacionamentoComprador }: IDeleteRealtionship) {
    try {
      const response = await api.delete("/relacionamento-comprador/deletar", {
        params: { IdRelacionamentoComprador },
      });

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async checkDocuments(OpportunityIdSalesforce: string) {
    try {
      const response = await api.get("/analise-de-credito/VerificaDocumentos", {
        params: { OpportunityIdSalesforce },
      });

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async sendToSAFI(body: ISAFIData) {
    try {
      const response = await api.post<{
        descricaoRetorno: string;
        tipoRetorno: number;
        codigoRetorno: number;
      }>("/analise-de-credito/SAFI", body);

      return {
        descricaoRetorno: response.data.descricaoRetorno,
        tipoRetorno: response.data.tipoRetorno,
        codigoRetorno: response.data.codigoRetorno,
      };
    } catch (error) {
      return {
        descricaoRetorno: "",
        tipoRetorno: 1,
        codigoRetorno: 1,
      };
    }
  }

  async getCorresponding({ oportunidadeIdSalesforce }: IGetCorresponding) {
    try {
      const response = await api.get("/analise-de-credito/Correspondentes", {
        params: { oportunidadeIdSalesforce },
      });

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
      return false;
    }
  }
  async getUrlS3(idAws: string) {
    try {
      const response = await api.get(
        "/relacionamento-comprador/obter-url-documento-S3",
        {
          params: { idAws },
        },
      );

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
      return false;
    }
  }
  async getProfission() {
    try {
      const response = await api.get("/conta/obter-profissoes");

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
      return false;
    }
  }
  async getCorrespondingRow({
    idEmpreendimento,
    regional,
    unidadeDeNegocio,
    regiao,
  }: IGetCorrespondingRow) {
    const body = {
      idEmpreendimento,
      regional,
      unidadeDeNegocio,
      regiao,
    };

    try {
      const response = await api.post(
        "/analise-de-credito/VerificaExisteFilaFilial",
        body,
      );

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
      return false;
    }
  }

  async updateRank({
    cpfCnpj,
    idOportunidade,
  }: {
    cpfCnpj: string;
    idOportunidade: string;
  }) {
    try {
      const response = await api.patch(
        "/oportunidade/atualizar-ranking",
        null,
        {
          params: {
            cpfCnpj,
            idOportunidade,
          },
        },
      );

      return response.data;
    } catch (err) {
      if (err instanceof AxiosError) {
        if (err.response !== undefined) {
          return {
            success: false,
            err: err.response!.data as string,
            status: err.status,
          };
        }
      }
      return {
        success: false,
        err: "Ocorreu algum erro, tente novamente mais tarde",
      };
    }
  }
}

const oportunityServiceInstance = new OportunityService();
export default oportunityServiceInstance;
